import React, { Fragment } from 'react';
import classnames from 'classnames';

import Icon from 'foundations/Icons/Icon';

import Svg from '@components/Svg';

import styles from './IconsUsage.css';

const Usage = () => (
  <Fragment>
    <section>
      <article className="flex-row">
        <h2 className={classnames(styles.paddingBottom, 'page-subtitle red')}>
          The icon family was created after a deep and thorough analysis of the defining characteristics of Tondo typeface, to achieve a coherent look. Details are essential to maintaining a balanced website. Therefore, it is important that an icon is pixel perfect and scalable.
        </h2>
      </article>
    </section>

    <section className="bg-grey with-padding">
      <article className="flex-row">
        <div className="left">
          <Svg name={'icons-usage-2'} height={188} width={176} style={styles.svg} />
        </div>
        <div className="right flex flex-column">
          <Svg name={'icons-usage-1'} height={253} width={337} />
          <ul className={classnames(styles.list)}>
            <li className="p">
              <strong>1. </strong>Stable angles (horizontal and vertical)
            </li>
            <li className="p">
              <strong>2. </strong>Curvy transitions
            </li>
            <li className="p">
              <strong>3. </strong>Rounded (exterior) and sharp (interior) edges
            </li>
            <li className="p">
              <strong>4. </strong>Rounded ends
            </li>
          </ul>
        </div>
      </article>
    </section>

    <section className="last with-padding">
      <article className="flex-row">
        <div className="left flex flex-align-center flex-justify-center">
          <div className={classnames(styles.iconScale, 'flex', 'flex-column', 'flex-justify-end')}>
            <Icon icon={'warning'} type={'20'} />
            <p className={'list'}>20px</p>
          </div>
          <div className={classnames(styles.iconScale, 'flex', 'flex-column', 'flex-justify-end')}>
            <Icon icon={'warning'} type={'40'} />
            <p className={'list'}>40px</p>
          </div>
          <div className={classnames(styles.iconScale, 'flex', 'flex-column', 'flex-justify-end')}>
            <Icon icon={'warning'} type={'80'} />
            <p className={'list'}>80px</p>
          </div>
        </div>
        <div className="right">
          <h2 className="h2 page-subtitle">Scalability</h2>
          <p>A custom icon family or set reinforces a brand’s overall consistency and graphic identity. The icons’ main purpose is to establish a common language and decrease ambiguity. Icons are a great way to draw attention, support calls to action, and guide users through a website. A scalable icon font is crucial to a responsive design, because it doesn’t lose quality when resized. By using vectors, the icon can be supported in higher resolution screens, as is the case with Retina displays. An icon font just needs to be loaded once, only requiring CSS to change its size and colour, as it is also lighter in size than an image sprite.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default Usage;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/IconsUsage/IconsUsage.js